import { Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import Label from "src/components/Label";
import { UserOrg } from "src/types/organization";
import { User } from "src/types/user";

export default function Email({ email }: UserOrg) {
	const queryClient = useQueryClient();
	const user = queryClient.getQueryData<User>(["user"]);
	return (
		<Stack flexDirection='row' alignItems={"center"} gap={1}>
			{user?.email === email && <Label color='primary'>{"Tu"}</Label>}
			<Typography variant='body2'>{email}</Typography>
		</Stack>
	);
}
